import { ReactComponent as ErrorHint } from './errorHint.svg';

export default ErrorHint;
